// src/lib/opportunity/fetchRepContactLocation.ts

import { requireSupabase } from "@/lib/supabase";

export type RepContactLocation = {
  name: string | null;
  phone: string | null;
  address_1: string | null;
  address_2: string | null;
  city: string | null;
  state: string | null;
  postal_code: string | null;
};

const SELECT = "name, phone, address_1, address_2, city, state, postal_code";

export async function fetchRepContactLocation(
  locationId: string,
): Promise<RepContactLocation | null> {
  const sb = requireSupabase();
  const { data, error } = await sb.from("locations").select(SELECT).eq("id", locationId).maybeSingle();
  if (error || !data) return null;
  const row = data as Record<string, string | null>;
  return {
    name: row.name?.trim() || null,
    phone: row.phone?.trim() || null,
    address_1: row.address_1?.trim() || null,
    address_2: row.address_2?.trim() || null,
    city: row.city?.trim() || null,
    state: row.state?.trim() || null,
    postal_code: row.postal_code?.trim() || null,
  };
}
